// frontend/src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom'; // Rimosso l'import
import api, { loginUser } from '../api'; // Importiamo l'istanza axios come default e loginUser come named
import { jwtDecode } from 'jwt-decode'; // Per decodificare il token JWT (potrebbe essere necessario installarlo: npm install jwt-decode)

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [token, setToken] = useState(null);
    const [user, setUser] = useState(null); // Nuovo stato per le informazioni utente
    // const navigate = useNavigate(); // Rimosso l'hook

    // Funzione helper non-hook per resettare lo stato di autenticazione
    const clearAuthData = useCallback(() => {
        localStorage.removeItem('access_token');
        setToken(null);
        setUser(null);
        setIsAuthenticated(false);
        delete api.defaults.headers.common['Authorization']; // Rimuove l'header di autorizzazione da axios
    }, []);

    const logout = useCallback(() => {
        clearAuthData();
    }, [clearAuthData]);

    const fetchUserProfile = useCallback(async (authToken) => {
        try {
            api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`; // <-- Reintrodotta
            const response = await api.get('/auth/users/me');
            if (!response.data.is_staff) {
                // I clienti del sito non possono usare il gestionale
                clearAuthData();
                return null;
            }
            setUser(response.data);
            setIsAuthenticated(true);
            return response.data;
        } catch (error) {
            console.error("Errore nel recupero del profilo utente:", error);
            clearAuthData(); // Usa la funzione helper
            return null;
        }
    }, [clearAuthData]); // Dipende da clearAuthData

    useEffect(() => {
        const storedToken = localStorage.getItem('access_token');
        if (storedToken) {
            try {
                const decodedToken = jwtDecode(storedToken);
                const currentTime = Date.now() / 1000;
                if (decodedToken.exp < currentTime) {
                    console.log("Token JWT scaduto.");
                    clearAuthData(); // Usa la funzione helper
                } else {
                    setToken(storedToken);
                    fetchUserProfile(storedToken);
                }
            } catch (error) {
                console.error("Errore nella decodifica del token:", error);
                clearAuthData(); // Usa la funzione helper
            }
        }
        setIsLoading(false);
    }, [fetchUserProfile, clearAuthData]); // Dipende da fetchUserProfile e clearAuthData

    const login = async (email, password, rememberMe) => {
        try {
            const data = await loginUser(email, password, rememberMe);
            const newToken = data.access_token;
            localStorage.setItem('access_token', newToken);
            setToken(newToken);
            api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`; // <-- Reintrodotta
            const userProfile = await fetchUserProfile(newToken);
            if (!userProfile) {
                throw new Error('Accesso riservato allo staff.');
            }
            return userProfile;
        } catch (error) {
            console.error("Errore di login:", error);
            clearAuthData(); // Usa la funzione helper
            throw error;
        }
    };



    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, isLoading, token, user }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
